import React, { useState } from 'react';
import {Box, CssBaseline, Typography, Card, CardContent, Collapse, IconButton, Button} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download';
import About from './Components/About';
import Skills from './Components/Skills';
import Header from "./Components/Header";
import Experience from "./Components/Experience";
import Education from "./Components/Education";
import Contact from "./Components/Contact";

const App = () => {

    const [skillsOpen, setSkillsOpen] = useState(true);
    const [experienceOpen, setExperienceOpen] = useState(true);
    const [educationOpen, setEducationOpen] = useState(true);
    
    const handleToggleSkills = () => setSkillsOpen(!skillsOpen);
    const handleToggleExperience = () => setExperienceOpen(!experienceOpen);
    const handleToggleEducation = () => setEducationOpen(!educationOpen);

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = `${process.env.PUBLIC_URL}/CV Aleksa Lukic.pdf`;
        link.download = 'CV Aleksa Lukic.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up the DOM
    };
    
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                background: 'linear-gradient(to bottom right, #f0f4f8, #d9e2ec)',
                minHeight: '100vh',
                padding: 2,
            }}
        >
            <CssBaseline />
            {/* Floating Toolbar on the Right Side */}
            <Button
                variant="contained"
                color="primary"
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
                sx={{
                    position: 'fixed',
                    top: { xs: 'auto', md: 20 },
                    bottom: { xs: 10, md: 'auto' },
                    right: 50,
                    width: { xs: '90%', md: 'auto' },
                    maxWidth: 300, 
                    zIndex: 1000,
                    marginX: { xs: 'auto', md: 0 }
                }}
            >
                Download Resume
            </Button>
            <Box
                sx={{
                    width: '100%',
                    maxWidth: '1000px',
                    bgcolor: 'white',
                    boxShadow: 3,
                    p: 3,
                    borderRadius: 2,
                }}
            >
                <Header />
                <About />
                {/* Skills Section */}
                <Card sx={{ mb: 2, boxShadow: 2, borderRadius: 2 }}>
                    <CardContent>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            onClick={handleToggleSkills}
                            sx={{ cursor: 'pointer' }}
                        >
                            <Typography variant="h6" fontWeight="bold">
                                Skills
                            </Typography>
                            <IconButton
                                onClick={handleToggleSkills}
                                sx={{
                                    transform: skillsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease',
                                }}
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        </Box>
                        <Collapse in={skillsOpen}>
                            <Skills />
                        </Collapse>
                    </CardContent>
                </Card>

                {/* Experience Section */}
                <Card sx={{mb: 2, boxShadow: 2, borderRadius: 2}}>
                    <CardContent>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            onClick={handleToggleExperience}
                            sx={{ cursor: 'pointer' }}
                        >
                            <Typography variant="h6" fontWeight="bold">
                                Experience
                            </Typography>
                            <IconButton
                                onClick={handleToggleExperience}
                                sx={{
                                    transform: experienceOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease',
                                }}
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        </Box>
                        <Collapse in={experienceOpen}>
                            <Experience />
                        </Collapse>
                    </CardContent>
                </Card>

                {/* Education Section */}
                <Card sx={{mb: 2, boxShadow: 2, borderRadius: 2}}>
                    <CardContent>
                        <Box
                            display='flex'
                            justifyContent='space-between'
                            alignItems='center'
                            onClick={handleToggleEducation}
                            sx={{cursor: 'pointer'}}
                        >
                            <Typography variant='h6' fontWeight='bold'>
                                Education
                            </Typography>
                            <IconButton
                                onClick={handleToggleEducation}
                                sx={{
                                    transform: educationOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3 ease'
                                }}
                            >
                                <ExpandMoreIcon />
                            </IconButton>
                        </Box>
                        <Collapse in={educationOpen}>
                            <Education />
                        </Collapse>
                    </CardContent>
                </Card>

                {/* Contact */}
                <Contact />
            </Box>
        </Box>
    );
};

export default App;
